export const DateTimeFormats = [
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm',
];

export const DateFormats = [
  'YYYY-MM-DD',
  'YYYY-MM-DD',
];

